import { makeStyles } from '@material-ui/core/styles';

import { RiExternalLinkLine } from '@remixicon/react';

import { Link } from '@backstage/ui';

import { AttachmentFragment } from '@spotify/confidence-graphql';

const useStyles = makeStyles({
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-4)',
    padding: 'var(--bui-space-4)',
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'var(--bui-space-1)',
  },
});

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const classes = useStyles();
  return (
    <div className={classes.info}>
      <Link
        href={artifact.uri}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.link}
      >
        {artifact.displayName || fallbackTitle(artifact)}
        <RiExternalLinkLine size={14} />
      </Link>
    </div>
  );
};
